const setCookie = (sKey, sValue, vEnd, sPath, sDomain, bSecure) => {
  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/.test(sKey)) {
    return;
  }
  let sExpires = '';
  if (vEnd) {
    switch (typeof vEnd) {
      case 'number':
        sExpires = '; max-age=' + vEnd;
        break;
      case 'string':
        sExpires = '; expires=' + vEnd;
        break;
      case 'object':
        if (vEnd.hasOwnProperty('toGMTString')) {
          sExpires = '; expires=' + vEnd.toGMTString();
        }
        break;
      default:
        break;
    }
  } else {
    const dObj = new Date();
    dObj.setMonth(dObj.getMonth() + 1);
    sExpires = '; expires=' + dObj.toUTCString();
  }
  document.cookie =
    sKey +
    '=' +
    sValue +
    sExpires +
    (sDomain ? '; domain=' + sDomain : '') +
    (sPath ? '; path=' + sPath : '') +
    (bSecure ? '; secure' : '');
};

export default setCookie;
